export const ClothDivisionCode = '008';
